
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lobby",
      function () {
        return require("private-next-pages/lobby.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lobby"])
      });
    }
  